export default "__VITE_ASSET__BgKdWNR4__"